import qs from 'qs';
import { client } from '@/client';

// 获取namespace本信息
export function getNamespaceOverview(clusterName) {
  return client.get(`/api/metrics/namespace/${clusterName}/overview`);
}

// namespace列表
export function getNamespaceList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/namespace/${clusterName}/list`, others);
}

// unload namespace
export function unloadNamespace(params) {
  return client.put(
    `/api/resource/namespace/unload${qs.stringify(params, { addQueryPrefix: true })}`,
  );
}

// 清除积压
export function clearBackLog(params) {
  return client.delete('/api/resource/namespace/clearBackLog', params);
}

// 图表信息
export function getNamespaceChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/namespace/${clusterName}`, others);
}

// 创建namespace
export function createNamespace(params) {
  return client.put('/api/resource/namespace/create?resAll=true', params);
}

// 删除namespace
export function deleteNamespace(params) {
  return client.delete('/api/resource/namespace/delete', params);
}

// 单个namespace总览
export function getNamespaceDetailOverview(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/namespace/${clusterName}`, others);
}

// 更新数据
export function updateNamespace(params) {
  return client.post('/api/console/namespace/update-metadata', params);
}

// 获取授权列表
export function getNamespaceGrantList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/namespace/${clusterName}/role`, others);
}

// 新增授权
export function grantPermissions(params) {
  return client.put('/api/resource/namespace/grant-role-permissions', params);
}

// 更新授权
export function undatePermissions(params) {
  return client.put('/api/resource/namespace/update-role-permissions', params);
}

// 删除授权
export function deletePermission(params) {
  return client.delete('/api/resource/namespace/revoke-role-permissions', params);
}

// 获取配置信息
export function getPolices(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/namespace/${clusterName}/polices`, others);
}

// 高级配置
export function getProPolices(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/namespace/${clusterName}/advancedPolices`, others);
}

// 更新消息保留策略
export function updateRetentionPolicy(params) {
  return client.put('/api/resource/namespace/update-retention-policy', params);
}

// 限流策略
export function updateLimitPolicy(params) {
  return client.put('/api/resource/namespace/update-limit-policy', params);
}

// schema兼容策略
export function updateSchemaCompatibilityPolicy(params) {
  return client.put('/api/resource/namespace/update-schema-compatibility-policy', params);
}

// 最大topic策略
export function updateTopicLimitPolicy(params) {
  return client.put('/api/resource/namespace/update-topic-limit-policy', params);
}

// 自动策略
export function updateAutoswitchPolicy(params) {
  return client.put('/api/resource/namespace/update-autoswitch-policy', params);
}

export function getGeoList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/namespace/list/${clusterName}`, others);
}

export function createGeo(params) {
  const { clusterName, ...others } = params;
  return client.put(
    `/api/resource/geo/namespace/addReplicationCluster/${clusterName}${qs.stringify(others, {
      addQueryPrefix: true,
    })}`,
    others,
  );
}

export function deleteGeo(params) {
  const { clusterName, ...others } = params;
  return client.delete(
    `/api/resource/geo/namespace/deleteReplicationCluster/${clusterName}`,
    others,
  );
}

export function updateGeoPolice(params) {
  return client.put(`/api/resource/geo/namespace/updateRatePolice`, params);
}
export function updateRatePoliceWithQuota(params) {
  return client.put(`/api/resource/geo/namespace/updateRatePoliceWithQuota`, params);
}

export function getGeoPolice(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/namespace/ratePolice/${clusterName}`, others);
}

// 配额策略
export function getQuotaRatePolice(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/namespace/quotaRatePolice/${clusterName}`, others);
}

export function deleteGeoPolice(params) {
  const { clusterName, ...others } = params;
  return client.delete(`/api/resource/geo/namespace/removeRatePolice/${clusterName}`, others);
}

export function deleteRatePolice(params) {
  const { clusterName, ...others } = params;
  return client.delete(
    `/api/resource/geo/namespace/removeRatePoliceWithQuota/${clusterName}`,
    others,
  );
}

export function getGeoChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/geo/namespace/${clusterName}`, others);
}

// 持久化策略
export function updatePersistencePolicy(params) {
  return client.put('/api/resource/namespace/update-persistence-policy', params);
}

// 获取默认配置
export function getDefaultNamespaceConfig(clusterName) {
  return client.get(`/api/metrics/namespace/${clusterName}/defaultConfig`);
}
